//Users
export const Save_User = (data) => ({
  type: "Save_User",
  payload: data,
});

export const Update_User = (data) => ({
  type: "Update_User",
  payload: data,
});

export const Remove_User = () => ({
  type: "Remove_User",
});

//Games
export const Save_Games_Data = (data) => ({
  type: "Save_Games_Data",
  payload: data,
});

// used for just to show the /otptest(cms otp page) after successfully done need to remove the below functions(Save_Property, Select_Property)
//this is used in the LoginRighttest.js file with sampleapiurl declared in config url file
export const Save_Property = (data) => ({
  type: "Save_Property",
  payload: data,
});

export const Select_Property = (data) => ({
  type: "Select_Property",
  payload: data,
});